import { render, staticRenderFns } from "./balanceEdit.vue?vue&type=template&id=4912eb47&scoped=true&"
import script from "./balanceEdit.vue?vue&type=script&lang=js&"
export * from "./balanceEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4912eb47",
  null
  
)

export default component.exports